module.exports = __webpack_public_path__ + "static/media/tanu.4443084f.png";